module.exports = __webpack_public_path__ + "static/media/Bunnelby_gaussian2.6ddb9217.png";